import { string as yupString } from "yup";

import { US_PHONE_REGEX } from "./regexes";

export const phoneNumberRequiredMessage = "Please enter a valid phone number.";
export const phoneNumberInvalidMessage =
  "Please enter a valid 10 digit phone number";

/** Yup string schema for a required US phone (matches other flows using TelephoneMask). */
export const phoneNumberYupString = () =>
  yupString()
    .required(phoneNumberRequiredMessage)
    .matches(US_PHONE_REGEX, phoneNumberInvalidMessage);
